export const authValidationConstants = {
  minPasswordLength: 6,
  maxPasswordLength: 50,
};

export const MAX_ITEM_QTY = 999;
